<template>
  <div class="m-auto text-white text-center">
    <h1 class="text-white mb-4">Welcome to CampdraftONE!</h1>
    <p class="lead mb-4 mb-md-5 mx-auto" style="max-width: 450px; font-size: 19px;"><strong>G’day {{name}}</strong>, before you get started, we need to make sure your membership details are correct.</p>
    <button class="btn btn-primary-dark px-4 px-md-5 py-2" @click.prevent="$emit('proceed')">Check my details</button>
  </div>
</template>

<script>
export default {
  props: ['name']
}
</script>



// WEBPACK FOOTER //
// src/views/Account/LoginOnce/LoginOnceWelcome.vue